import { useCallback } from 'react';
import { useKeycloak } from '@react-keycloak-fork/ssr';
import persistor from 'utils/persistor';
import { useMatomo } from '@jonkoops/matomo-tracker-react';
import { Routes } from 'utils/routes';
import { useRouter } from 'next/router';

export default function useAuthentication() {
    const { trackEvent } = useMatomo();
    const { initialized, keycloak } = useKeycloak();

    const { loginHintEmail } = useRouter().query;

    const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

    const authenticated = Boolean(persistor.getTokens().token);

    const methods = {
        login: useCallback(({ redirectPath = Routes.MyPenly.Dashboard, type = 'replace' } = {}) => {
            trackEvent({ category: 'account', action: 'login' });
            let loginUrl = keycloak.createLoginUrl({ redirectUri: `${origin}/${redirectPath}` });

            if (loginHintEmail) loginUrl += `&email=${loginHintEmail}`;

            if (type === 'replace') {
                window.location.replace(loginUrl);
            } else if (type === 'push' || type === 'click') {
                window.location.href = loginUrl;
            } else {
                throw new Error(`Invalid login type: ${type}`);
            }
        }, [keycloak, origin, trackEvent, loginHintEmail]),
        logout: useCallback(({ redirectPath = '' } = {}) => {
            persistor.resetTokens();
            trackEvent({ category: 'account', action: 'logout' });
            const logoutUrl = keycloak.createLogoutUrl({ redirectUri: `${origin}/${redirectPath}` });
            window.location.href = logoutUrl;
        }, [keycloak, origin, trackEvent]),
        updateToken: useCallback((seconds = 5) => {
            keycloak.updateToken(seconds);
        }, [keycloak]),
    };

    return { initialized, authenticated, ...methods };
}
